import {EntityType} from '../document';

export interface GetParams {
  startRow: number;
  endRow: number;
  sortDirection: 'asc' | 'desc';
  sortProperty: string;
  filterProperty?: string;
  filterValue?: string;

  // Parametros del GET de Documents
  entityId?: number;
  companyId?: number;
  entityType?: EntityType;
}

export interface GetAdvancedParams {
  startRow: number;
  endRow: number;
  sortDirection: 'asc' | 'desc';
  sortProperty: string;
  filterGroups?: FilterGroup[][];
  filterProperty?: string;
  filterValue?: string;
}

export interface FilterGroup {
  property: string,
  value: string | number | boolean | null,
  operator: AdvancedFilterOperators,
  operatorValue?: number,
  collectionGroup?: string,
}

export type AdvancedFilterOperators =
  'Contains' // Text contains value (LIKE %value%)
  | 'StartsWith' // Text starts with value (LIKE value%)
  | 'EndsWith' // Text ends with value (LIKE %value)
  | 'Equals' // Exact match (==)
  | 'NotEquals' // 	Value is in list (provide array as value)
  | 'LessThan' // Less than or equal to (<=)
  | 'LessThanOrEqual' // Less than (<)
  | 'GreaterThan' // Greater than (>)
  | 'GreaterThanOrEqual'; // Greater than or equal to (>=)


